module.exports = __webpack_public_path__ + "img/category-9.5141a8cf.svg";